// @flow
import React from 'react'
import ReactDOM from 'react-dom'

import AppViewContainer from './modules/AppViewContainer'

ReactDOM.render(<AppViewContainer />, document.getElementById('root'))

// The app previously registered a service worker (via create-react-app precache).
// That is gone now, so proactively unregister any worker still cached in a
// returning user's browser to avoid serving stale assets.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister())
  })
}
